<div class="numberplate-scan" [ngClass]="styleClass">
  <sc-flex vertical [centered]="true" stretchContent fitHeight>
    <div class="identifier">{{title}}</div>
    <sc-content-spacer [double]="true"></sc-content-spacer>
    @if (scanResult == null) {
      <div class="numberplate">&nbsp;</div>
    }
    @if (scanResult != null) {
      <div class="numberplate">{{scanResult?.numberplate}}</div>
    }
  </sc-flex>
</div>
